exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ni[data-v-7ddc97f3] {\r\n  color: #9abc66;\r\n  font-size: 100px;\r\n  line-height: 200px;\r\n  margin-left: -15px;\n}\n.card[data-v-7ddc97f3] {\r\n  background: white;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 3px #c8d0d8;\r\n  display: inline-block;\r\n  margin: 0 auto;\r\n  width: 100%;\n}\r\n", ""]);

// exports
